class BrandSlider extends HTMLElement {
    constructor() {
        super();

        setTimeout(() => {
            const splideElem = this.querySelector('[id^="BrandSlider-splide-"]');
            this.splide = new Splide(splideElem, {
                type: "loop",
                perPage: 6,
                gap: "2rem",
                pagination: false,
                breakpoints: {
                    1152: {
                        perPage: 5
                    },
                    768: {
                        perPage: 4
                    },
                    480: {
                        perPage: 3
                    }
                }
            });
            this.splide.mount();
        }, 10);
    }

    goToSlide(slideNum) {
        this.splide.go(slideNum);
    }
}

customElements.define("brand-slider", BrandSlider);
